import useIsMobile from '@/helpers/commonHooks/useIsMobile'
import PreperResetPwdCardPc from './PreperResetPwdCardPc/PreperResetPwdCardPc'
import PreperResetPwdCardMobile from './PreperResetPwdCardMobile/PreperResetPwdCardMobile'

function PreperResetPwdCard() {
  const isMobile = useIsMobile()
  return isMobile ? <PreperResetPwdCardMobile /> : <PreperResetPwdCardPc />
}

export default PreperResetPwdCard
